module.exports = __webpack_public_path__ + "img/mile6-m@1.d5af0bd9.jpg";